<vc-chart-wrapper class="vc-findings-by-category-wrapper" [contentHeight]="contentHeight" [loading]="loading">
    @if (title) {
        <h2 chartActionsTitle class="h3-heading">{{ title }}</h2>
    }
    <ng-container ngProjectAs="[chartActionsRightSide]">
        <ng-content select="[chartActionsRightSide]"></ng-content>
    </ng-container>
    <highcharts-chart
        class="no-title vc-findings-by-category-chart"
        [style.height]="height"
        [options]="options"
        [update]="updating">
    </highcharts-chart>
</vc-chart-wrapper>
